module.exports = __webpack_public_path__ + "static/media/vanessarusu-logo.675b78ce.svg";